import { create } from 'zustand';

type PinnedConversationState = {
  pinnedConversationId: string | null;
  setPinnedConversationId: (id: string | null) => void;
};

/**
 * Tracks the conversation the user is currently working through from the
 * unanswered-messages popup. The pinned conversation is rendered at the top
 * of the inbox / proposals lists so the auto-switch flow stays anchored at
 * the top while the user walks downwards through their unanswered queue.
 */
export const usePinnedConversationStore = create<PinnedConversationState>(
  set => ({
    pinnedConversationId: null,
    setPinnedConversationId: id => set({ pinnedConversationId: id }),
  }),
);
